import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { deviceResolver } from './fleet/device/device-details/device-details.resolver';

const routes: Routes = [
  {
    path: 'fleet/devices/:id/sticker',
    canActivate: [AuthGuard],
    loadComponent: () => import('./fleet/device/device-sticker/device-sticker.component').then((m) => m.DeviceStickerComponent),
    resolve: { docs: deviceResolver },
    data: { selectedTab: 0 },
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'auth',
    loadComponent: () => import('./auth/auth-layout/auth-layout.component').then((m) => m.AuthLayoutComponent),
    children: [
      { path: 'login', loadComponent: () => import('./auth/login/login.component').then((m) => m.LoginComponent) },
      { path: 'forgot-password', loadComponent: () => import('./auth/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent) },
      { path: 'reset-password', loadComponent: () => import('./auth/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent) },
    ],
  },
  {
    path: '',
    canActivateChild: [
      AuthGuard,
    ],
    loadComponent: () => import('./_layouts/app-grid-layout/app-grid-layout.component').then((m) => m.AppGridLayoutComponent),
    children: [
      { path: 'customers', loadChildren: () => import('./customers/customers.module').then((m) => m.CustomersModule) },
      { path: 'fleet', loadChildren: () => import('./fleet/fleet.module').then((m) => m.FleetModule) },
      { path: 'library', loadChildren: () => import('./library/library.module').then((m) => m.LibraryModule) },
      { path: 'scheduling', loadChildren: () => import('./scheduling/scheduling.module').then((m) => m.SchedulingModule) },
      { path: 'streaming', loadChildren: () => import('./streaming/streaming.module').then((m) => m.StreamingModule) },
      { path: 'settings', loadChildren: () => import('./settings/settings.module').then((m) => m.SettingsModule) },
      /*
      DJ-339: when user clicks on logout and then on login, he is redirected to "404 not found" page.
      This is due to the fact that cognito redirects to {redirecturi}#id_token=....
      Ideally we should specify a redirecturi that already contains the initial route. In this case the router would not override it as
      specified at https://manfredsteyer.github.io/angular-oauth2-oidc/docs/additional-documentation/routing-with-the-hashstrategy.html.

      However, since we are very unlucky, we can't use LocationPathStrategy (urls without fragments) due to S3/cloudfront way of routing,
      and we can't set a redirecturi with a predefined fragment due to cognito limitation.
      */
      { path: 'id_token', redirectTo: '/library', pathMatch: 'full' },
      { path: '', redirectTo: '/library', pathMatch: 'full' },
    ],
  },
  {
    path: 'error',
    loadComponent: () => import('./_layouts/error-layout/error-layout.component').then((m) => m.ErrorLayoutComponent),
    children: [
      { path: 'not-found', loadComponent: () => import('./_global/not-found/not-found.component').then((m) => m.NotFoundComponent) },
      { path: 'not-authorized', loadComponent: () => import('./_global/not-authorized/not-authorized.component').then((m) => m.NotAuthorizedComponent) },
      { path: 'service-unavailable', loadComponent: () => import('./_global/service-unavailable/service-unavailable.component').then((m) => m.ServiceUnavailableComponent) },
    ],
  },
  { path: '**', redirectTo: '/error/not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true }),
  ],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule { }
